import React from 'react'
import useSelector from 'hooks/use-selector'
import VariantButton from 'containers/QuickShopProductSidebar/components/VariantButtons/components/VariantButton'
import {
  FULL_SIZE,
  FULL_SIZE_LOGO

} from 'modules/variant/constants'
import getSizeGuideLabelProductSelectUtil from 'modules/product/redux/selectors/get-size-guide-label/utils'
import sanitizeOptionValue from 'containers/QuickShopProductSidebar/components/ColorSwatches/util/sanitize-option-value'
import getByVariantIdsProductsSelector from 'modules/product/redux/selectors/get-by-variant-ids-products'
import sortVariantsByAvailabilityUtil from 'containers/QuickShopProductSidebar/components/VariantButtons/components/SampleVariantButtons/utils/sort-variants-based-on-availability/index.js'
import useDispatch from 'hooks/use-dispatch'

const FullSizeVariantButtons = ({ fullSizeVariants, isFullSizeOutOfStock }) => {
  const uniqueFullSizeVariants = []
  const variantReduxMap = useSelector(getByVariantIdsProductsSelector(fullSizeVariants))
  console.log('variantReduxMap', variantReduxMap)
  const sortedFullSizeVariants = sortVariantsByAvailabilityUtil(fullSizeVariants, variantReduxMap)
  const dispatch = useDispatch()

  return sortedFullSizeVariants?.map((variant, index) => {
    if (uniqueFullSizeVariants.includes(variant.price)) {
      return null
    }

    uniqueFullSizeVariants.push(variant.price)

    const variantRedux = variantReduxMap[variant.id]
    const sizeLabel = getSizeGuideLabelProductSelectUtil({
      isADeluxeSample: false,
      isAFreeSample: false,
      currentVariant: variant,
      fullSizeOption: variant?.size_option,
      short: true,
      isMiniCart: true
    })

    return (
      <VariantButton
        key={variant.id + index}
        LogoUrl={FULL_SIZE_LOGO}
        title={FULL_SIZE}
        subTitle={sanitizeOptionValue(sizeLabel)}
        sku={variantRedux?.sku}
        productId={variantRedux?.product_id}
        variantId={variantRedux?.variant_id}
        dispatch={dispatch}
        isSample={false}
        price={variant?.price}
        isOutOfStock={isFullSizeOutOfStock}
        hasSecondaryFullSizeVariant={false}
        fullSizeVariantId={variantRedux?.variant_id}
        fullSizeProductId={variantRedux?.product_id}
        productVariant={variantRedux}
        variant={variant}
      />
    )
  })
}

export default FullSizeVariantButtons
